import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-standing__top as-row-name"
}
const _hoisted_2 = { class: "as-standing__top" }
const _hoisted_3 = { class: "as-standing__table" }
const _hoisted_4 = {
  class: /*@__PURE__*/_normalizeClass([
            'as-standing__table-row',
            'as-standing__table-row-head',
          ])
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "as-has-arrow-right"
}
const _hoisted_7 = { class: "as-has-arrow-right-info" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "as-stt" }
const _hoisted_10 = { class: "as-match__team" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "as-standing__table-text" }
const _hoisted_13 = { class: "as-standing__table-column as-text-center" }
const _hoisted_14 = { class: "as-standing__table-column as-text-center as-c-w" }
const _hoisted_15 = { class: "as-standing__table-column as-text-center as-c-l" }
const _hoisted_16 = { class: "as-standing__table-column as-text-center" }
const _hoisted_17 = { class: "as-standing__table-column as-text-center" }
const _hoisted_18 = { class: "as-standing__table-column as-text-center as-coulumn-show-full" }
const _hoisted_19 = { class: "as-standing__table-column as-text-center as-coulumn-show-full" }
const _hoisted_20 = { class: "as-standing-tag__list" }
const _hoisted_21 = ["title"]

import { ref, computed, nextTick, onMounted, getCurrentInstance } from "vue";
import IconArrownDown from "~src/components/icons/IconArrownDown.vue";
import IconMenu from "~src/components/icons/IconMenu.vue";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import IconArrowRight from "~src/components/icons/IconArrowRight.vue";
import type {
  IStanding,
  IMatch,
  ITeam,
  IStandingsRow,
  IStandingsTable,
  IPromotion,
  IRecent,
} from "~src/interfaces//basketball";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  determineMatchResult,
  determineMatchResultVolleyball,
  getTeamName,
} from "~src/helpers/basketball/index";
import MatchEnum from "~src/enums/MatchEnum";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  standing: IStanding;
  match?: IMatch;
  isPopup: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StandingListTab',
  props: {
    standing: {},
    match: {},
    isPopup: { type: Boolean, default: true }
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const isShowFull = ref(false);
const activeTab = ref("all");
const tabs = ref([
  {
    title: "Tất cả",
    key: "all",
  },
  {
    title: "Sân nhà",
    key: "home",
  },
  {
    title: "Sân khách",
    key: "away",
  },
]);

const columns = [
  {
    title: "#",
    name: "position",
    class: "as-text-center as-standing__table-column-stt as-column-head",
  },
  {
    title: "Team",
    name: "team_name",
    class: "as-standing__table-column-team as-column-head",
  },
  {
    title: "P",
    name: "mb",
    class: "as-text-center as-c-mb",
  },
  {
    title: "W",
    name: "won",
    class: "as-text-center as-c-w",
  },
  {
    title: "L",
    name: "lost",
    class: "as-text-center as-c-l",
  },
  {
    title: "S",
    name: "s",
    class: "as-text-center as-c-s",
  },
  {
    title: "PTS",
    name: "pts",
    class: "as-text-center as-c-pts",
  },
  {
    title: "Diff",
    name: "diff",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "Phong độ",
    name: "points1",
    class: "as-text-center as-scroll-item-active as-coulumn-show-full",
  },
  // {
  //   title: "Tiếp",
  //   name: "next",
  //   class:
  //     "as-text-center as-scroll-item-active as-column-next as-coulumn-show-full",
  // },
];

const sort = ref({
  column: "",
  type: "ASC",
});

const activeTitle = ref("");
const changeTitles = (val: string) => {
  activeTitle.value = val;
};

const rowsTitles = computed(() => {
  if (!props?.standing?.standings) {
    return [];
  }

  const _rowsTitles: any = [];
    props.standing.standings.map((item: any) => {
      _rowsTitles.push({
          key: item.id,
          title: item.name,
        });
    });


  return _rowsTitles;
});

const rowsConverted = computed(() => {
  if (!props?.standing?.standings) {
    return [];
  }
  const standingJson: any = [];
  let __standings: any[] = props.standing.standings;
  if (activeTitle.value) {
    __standings = __standings.filter(
      (item: any) => item.id === activeTitle.value
    );
  }
  const instance: any = getCurrentInstance();

  __standings.map((item: any) => {
    const rows = [];
    for (const row of item.rows) {
      const _won = Number(row.won || 0);
      const _lost = Number(row.lost || 0);
      const _p = _won + _lost;
      const _pct = _p ? (Number(_won / _p || 0) * 100).toFixed(1) || "0" : 0;
      rows.push({
        ...row,
        team_name: getTeamName(props.standing.teams, row.team_id),
        next:
          row?.next_match?.home_team?.id === row.team_id
            ?  instance.proxy?.getImgUrlBySport("team", row?.next_match?.away_team?.id)
            :  instance.proxy?.getImgUrlBySport("team", row?.next_match?.home_team?.id),
        won: _won,
        lost: _lost,
        p: _p,
        pct: _pct,
        pts: row.points || 0,
      });
    }

    rows?.sort((a: any, b: any) => {
      if (activeTab.value === "all") {
        // chọn sắp xếp
        if (sort.value.column) {
          // sắp xếp string
          if (sort.value.column === "team_name") {
            if (sort.value.type === "DESC") {
              return a.team_name.localeCompare(b.team_name);
            } else {
              return b.team_name.localeCompare(a.team_name);
            }
          } else {
            if (sort.value.type === "DESC") {
              return a[sort.value.column] - b[sort.value.column];
            } else {
              return b[sort.value.column] - a[sort.value.column];
            }
          }
        } else {
          return a.position - b.position;
        }
      } else {
        if (sort.value.column) {
          if (sort.value.column === "team_name") {
            if (sort.value.type === "DESC") {
              return a.team_name.localeCompare(b.team_name);
            } else {
              return b.team_name.localeCompare(a.team_name);
            }
          } else {
            if (sort.value.type === "DESC") {
              return (
                a[`${activeTab.value}_${sort.value.column}`] -
                b[`${activeTab.value}_${sort.value.column}`]
              );
            } else {
              return (
                b[`${activeTab.value}_${sort.value.column}`] -
                a[`${activeTab.value}_${sort.value.column}`]
              );
            }
          }
        } else {
          return (
            a[`${activeTab.value}_position`] - b[`${activeTab.value}_position`]
          );
        }
      }
    });
    standingJson.push({
      id: item.id,
      name: item.name,
      scope: item.scope,
      rows: rows,
    });
  });

  if (standingJson.length > 1) {
    const { home_team_id, away_team_id } = props.standing.match;
    const result = standingJson.filter((arr: any) => {
      const isIncludeHomeTeam = arr.rows.some(
        (row: any) => row.team_id === home_team_id
      );
      const isIncludeAwayTeam = arr.rows.some(
        (row: any) => row.team_id === away_team_id
      );
      if (isIncludeHomeTeam && isIncludeAwayTeam) {
        return arr;
      }
    });
    const { kind } = props.standing.match;
    if (result.length > 1) {
      const currentSeason = result.filter((arr: any) => {
        // Statistics range，1-season，2-qualifier，3-group stage，4-preseason，5-regular season，6-elimination (playoffs)
        // Type id，1-Regular season，2-Playoffs，3-Preseason，4-All-Star，5-Cup，6-play offs，0-None
        if (kind === 1) {
          return arr.scope === 5;
        }
        if (kind === 2) {
          return arr.scope === 6;
        }
        if (kind === 3) {
          return arr.scope === 4;
        }
      });
      if (currentSeason.length === 0) {
        return result.map((item: any) => {
          return item.rows;
        });
      }
      return currentSeason.map((item: any) => {
        return item.rows;
      });
    }

    if (result.length === 0) {
      let data = standingJson.filter((item: any) => {
        if (kind === 1) {
          return item.scope === 5;
        }
        if (kind === 2) {
          return item.scope === 6;
        }
        if (kind === 3) {
          return item.scope === 4;
        }
      });
      if (data.length === 0) {
        return standingJson.map((item: any) => {
          return item.rows;
        });
      }
      if (data.length <= 2) {
        // two team in two different standing
        data = data.map((i: any) => i.rows);
        return data;
      }
      const result = standingJson.filter((arr: any) => {
        const isIncludeHomeTeam = arr.rows.some(
          (row: any) => row.team_id === home_team_id
        );
        const isIncludeAwayTeam = arr.rows.some(
          (row: any) => row.team_id === away_team_id
        );
        if (isIncludeHomeTeam || isIncludeAwayTeam) {
          return arr;
        }
      });
      if (result.length !== 0) {
        return result.map((item: any) => {
          return item.rows;
        });
      }
      data = data.map((i: any) => i.rows);
      return data;
    }

    return result.map((item: any) => {
      return item.rows;
    });
  }
  const _standings = standingJson.map((item: any) => {
    return item.rows;
  });

  return _standings;
});

const changeTab = (val: string) => {
  activeTab.value = val;
};

const sortData = (columnName: string) => {
  let type = "ASC";
  if (sort.value.column === columnName) {
    if (sort.value.type === "ASC") {
      type = "DESC";
    }
  }
  sort.value = {
    column: columnName,
    type: type,
  };
};

const getRowdata = (row: any, field: string) => {
  if (field === "p") {
    let _win = row.win ?? 0;
    let _loss = row.loss ?? 0;

    if (activeTab.value === "home") {
      _win = row.home_win ?? 0;
      _loss = row.home_lose ?? 0;
    } else if (activeTab.value === "away"){
      _win = row.away_win ?? 0;
      _loss = row.away_lose ?? 0;
    }

    return parseInt(_win + _loss);

  } else if (field === "win") {
    if (activeTab.value === "all") {
      return row.win;
    } else if (activeTab.value === "home") {
      return row.home_win;
    } else {
      return row.away_win;
    }
  } else if (field === "loss") {
    if (activeTab.value === "all") {
      return row.loss;
    } else if (activeTab.value === "home") {
      return row.home_lose;
    } else {
      return row.away_lose;
    }
  } else if (field === "sets") {
    let sets_win = row.sets_win ?? 0;
    let sets_loss = row.sets_loss ?? 0;
    if (activeTab.value === "home") {
      sets_win = row.home_sets_win ?? 0;
      sets_loss = row.home_sets_lose ?? 0;
    } else if (activeTab.value === "away"){
      sets_win = row.away_sets_lose ?? 0;
      sets_loss = row.away_sets_win ?? 0;
    }
    return `${sets_win}:${sets_loss}`;
  } else if (field === "points") {
    if (activeTab.value === "all") {
      return row.points;
    } else if (activeTab.value === "home") {
      return row.home_points ?? 0;
    } else {
      return row.away_points ?? 0;
    }
  } else if (field === "diff") {
    let sets_win = row.sets_win ?? 0;
    let sets_loss = row.sets_loss ?? 0;
    if (activeTab.value === "home") {
      sets_win = row.home_sets_win ?? 0;
      sets_loss = row.home_sets_lose ?? 0;
    } else if (activeTab.value === "away"){
      sets_win = row.away_sets_lose ?? 0;
      sets_loss = row.away_sets_win ?? 0;
    }

    const diff = sets_win - sets_loss;
    
    return diff > 0 ? `+${diff}` : `${diff}`;
  }
};

const getRecentTitle = (recent: any, teamId: string) => {
  const scores = recent?.scores;
  const totalHomeGoals = scores['ft'][0];
  const  totalAwayGoals = scores['ft'][1];

  return `${totalHomeGoals}:${totalAwayGoals} (${
    recent.home_team?.name
  } - ${recent.away_team?.name}) ${formatLocalTime(recent.match_time)}`;
  return 'OK'
};

const getRecent = (row: any) => {
  if (activeTab.value === "all") {
    return row.recent_matches;
  } else {
    return row[`${activeTab.value}_matches`];
  }
};

const getContrastColor = (hexcolor: string) => {
  // Remove the hash if it's there
  hexcolor = hexcolor.replace("#", "");
  if (hexcolor === "") return "white";

  // Parse r, g, b values
  let r = parseInt(hexcolor.substring(0, 2), 16); // hex to integer
  let g = parseInt(hexcolor.substring(2, 4), 16);
  let b = parseInt(hexcolor.substring(4, 6), 16);

  // Determine the brightness of the background
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is under 128, return white, otherwise return black
  return brightness < 128 ? "white" : "black";
};

const activeItems = ref<HTMLDivElement | null>(null);
const standingRef = ref<HTMLDivElement | null>(null);

const scrollToActiveItem = (container: HTMLDivElement, activeItem: HTMLDivElement) => {
  try {
    if (!container || !activeItem) return;

    const containerRect = container.getBoundingClientRect();
    const activeItemRect = activeItem.getBoundingClientRect();

    const scrollLeft = container.scrollLeft + activeItemRect.left - containerRect.left;

    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  } catch (error) {
    console.error('Error in scrollToActiveItem:', error);
  }
}

const handleShowFull = async () => {
  isShowFull.value = !isShowFull.value;
  await nextTick();

  if (!standingRef.value || !isShowFull.value) return;

  const _tables = standingRef.value.querySelectorAll<HTMLDivElement>(".as-standing__table") ?? [];
  if (!_tables?.length) return;

  Array.from(_tables).forEach((table) => {
    try {
      const activeItem = table.querySelector<HTMLDivElement>(".as-scroll-item-active");
      if (!activeItem) return;
    
      requestAnimationFrame(() => {
        setTimeout(() => {
          scrollToActiveItem(table, activeItem);
        }, 100);
      });
    } catch (error) {
      console.error('Error scrolling to active item:', error);
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (rowsConverted.value.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`as-parent-standing as-parent-standing-${siteName.value}`),
        ref_key: "standingRef",
        ref: standingRef
      }, [
        (rowsTitles.value[0]?.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(TabsBtn, {
                tabs: rowsTitles.value,
                activeTab: activeTitle.value,
                onChange: changeTitles
              }, null, 8, ["tabs", "activeTab"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TabsBtn, {
            tabs: tabs.value,
            activeTab: activeTab.value,
            onChange: changeTab
          }, null, 8, ["tabs", "activeTab"]),
          _createElementVNode("div", {
            class: _normalizeClass(["as-menu", {
          'as-active': isShowFull.value,
        }]),
            onClick: handleShowFull
          }, [
            _createVNode(IconMenu)
          ], 2)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsConverted.value, (rows, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["as-standing", {
        'as-show-full': isShowFull.value,
        'as-scrolling as-scrolling__have-tab as-scrolling__result-popup as-volleyball':
          _ctx.isPopup,
      }]),
            key: key
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
                  return _createElementVNode("div", {
                    key: column.name,
                    onClick: ($event: any) => (sortData(column.name)),
                    class: _normalizeClass(`as-standing__table-column ${column.class}`),
                    type: "button",
                    ref_for: true,
                    ref: column.name === 'next' ? 'activeItems' : undefined
                  }, [
                    (column.name === 'points1')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createTextVNode(_toDisplayString(column.title) + " ", 1),
                            (sort.value.column === column.name)
                              ? (_openBlock(), _createBlock(IconArrownDown, {
                                  key: 0,
                                  class: _normalizeClass(["as-d-inline-flex", {
                    'as-sort-down': sort.value.type === 'ASC',
                    'as-sort-up': sort.value.type === 'DESC',
                  }])
                                }, null, 8, ["class"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(IconArrowRight, { fill: "#CCC" })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createTextVNode(_toDisplayString(column.title) + " ", 1),
                          (sort.value.column === column.name)
                            ? (_openBlock(), _createBlock(IconArrownDown, {
                                key: 0,
                                class: _normalizeClass(["as-d-inline-flex", {
                  'as-sort-down': sort.value.type === 'ASC',
                  'as-sort-up': sort.value.type === 'DESC',
                }])
                              }, null, 8, ["class"]))
                            : _createCommentVNode("", true)
                        ]))
                  ], 10, _hoisted_5)
                }), 64))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows, (row, keyRow) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: keyRow,
                  class: _normalizeClass(["as-standing__table-row", {
            active:
              _ctx.match?.home_team_id === row.team_id ||
              _ctx.match?.away_team_id === row.team_id,
          }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["as-standing__table-column as-standing__table-column-stt as-text-center", {
              'as-stt-popup': _ctx.isPopup,
            }])
                  }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(keyRow + 1), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["as-standing__table-column as-standing__table-column-team", {
              'as-team-popup': _ctx.isPopup,
            }])
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: _ctx.getImgUrlBySport('team', row.team_id),
                        class: "as-match__team-logo",
                        alt: row.team_name
                      }, null, 8, _hoisted_11),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(row.team_name), 1)
                    ])
                  ], 2),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(getRowdata(row, 'p')), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(getRowdata(row, 'win')), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(getRowdata(row, 'loss')), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(getRowdata(row, 'sets')), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(getRowdata(row, 'points')), 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(getRowdata(row, 'diff')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRecent(row), (recent, keyRecent) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: keyRecent,
                          class: _normalizeClass(`as-standing-tag as-standing-tag__${_unref(determineMatchResultVolleyball)(
                  recent,
                  row.team_id
                ).charAt(0)}`),
                          title: getRecentTitle(recent, row.team_id)
                        }, _toDisplayString(_unref(determineMatchResultVolleyball)(recent, row.team_id).charAt(0)), 11, _hoisted_21))
                      }), 128))
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ], 2))
        }), 128))
      ], 2))
    : (_openBlock(), _createBlock(NoData, { key: 1 }))
}
}

})